<script setup lang="ts">
// In-game admin = minimal device-level controls (rename device, change API,
// clear token). All prize/event management lives in the dashboard.
// Per handoff section 3.2: "Replace the in-game admin with a web dashboard".
import { ref } from 'vue';
import { apiBase, deviceToken, clearDeviceToken, setApiBase } from '../lib/api';
import { useGameStore } from '../stores/game';

const store = useGameStore();
const base = ref(apiBase());

function reset() {
  if (!confirm('Clear device pairing? You will need to re-enter the token.')) return;
  clearDeviceToken();
  location.reload();
}

function saveBase() {
  setApiBase(base.value.trim().replace(/\/$/, ''));
}
</script>

<template>
  <div class="adm">
    <header>
      <div class="ttl">Device Settings</div>
      <button class="btn btn-outline btn-sm" @click="store.exitAdmin()">Done</button>
    </header>
    <div class="body">
      <section>
        <h3>Device</h3>
        <div class="row"><label>Name</label><div class="val">{{ store.config?.device.name ?? '—' }}</div></div>
        <div class="row"><label>Event</label><div class="val">{{ store.config?.event.name ?? '—' }}</div></div>
        <p class="hint">To rename or reassign this device, use the dashboard.</p>
      </section>
      <section>
        <h3>API</h3>
        <label>Base URL</label>
        <input v-model="base" type="text" />
        <button class="btn btn-gold btn-sm" @click="saveBase">Save URL</button>
      </section>
      <section>
        <h3>Token</h3>
        <p class="hint">Stored token: {{ deviceToken() ? deviceToken()!.slice(0, 12) + '…' : 'none' }}</p>
        <button class="btn btn-outline btn-sm danger" @click="reset">Clear Token & Re-Pair</button>
      </section>
    </div>
  </div>
</template>

<style scoped>
.adm {
  min-height: 100vh;
  background: var(--dark);
  display: flex;
  flex-direction: column;
}
header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: var(--dark2);
  border-bottom: 2px solid var(--or-dk);
}
.ttl {
  font-weight: 700;
  font-size: 16px;
}
.btn-sm {
  padding: 6px 12px;
  font-size: 12px;
}
.body {
  padding: 18px;
  overflow-y: auto;
}
section {
  background: var(--dark2);
  border: 1px solid var(--surf3);
  border-radius: var(--r);
  padding: 16px;
  margin-bottom: 14px;
}
h3 {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 12px;
}
.row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  font-size: 13px;
}
.row:last-child {
  border: none;
}
label {
  color: var(--grey);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  display: block;
  margin: 8px 0 4px;
}
.val {
  color: var(--white);
}
.hint {
  color: var(--grey);
  font-size: 12px;
  margin: 8px 0;
}
.btn.danger {
  border-color: var(--red);
  color: var(--red);
}
</style>
